import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import { reactive, computed, ref, nextTick } from "vue";
import { documentService } from "@/api/services/document";
import { useSettingsStore } from "@/api/store/settings";
import { useRouter } from "vue-router";

import FormField from "@/components/SwandoolaDocBuilder/FormField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentViewer',
  setup(__props) {

const router = useRouter();

const settingsStore = useSettingsStore();

const state = reactive({
  document: null as any,
});

const documentId = computed(() => router.currentRoute.value.params.id);

const fetchDocument = async () => {
  documentService
    .showTemplate(documentId.value as string)
    .then((response) => {
      state.document = response;
    })
    .catch((error) => {
      console.log(error);
    });
};

fetchDocument();

const checkRequiredFields = async (data: any): Promise<boolean> => {
  for (let index = 0; index < data.items.length; index++) {
    const item = data.items[index];

    if (
      item.isRequired &&
      (!item.value || item.value.toString().trim() === "")
    ) {
      await nextTick();

      const el = document.querySelector(
        `[data-index="${index}"]`
      ) as HTMLElement;

      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.focus?.();
      }

      alert(`Please fill in the required field: "${item.label}"`);
      return false;
    }
  }

  return true;
};

const processLinks = (content: any) => {
  if (!content || content.length === 0) {
    return content;
  }

  // Regular expression to find URLs in text
  const urlRegex = /\bhttps?:\/\/[^\s<>]+/g;

  return content.replace(
    urlRegex,
    (url) => `<a href="${url}" target="_blank">${url}</a>`
  );
};

const submit = async (completed: boolean) => {
  if (completed && !(await checkRequiredFields(state.document.data))) {
    return;
  }

  const response = await documentService.update(state.document.id, {
    data: state.document.data,
    completed: completed,
  });

  fetchDocument();
};

const getSectionItems = (sectionIndex: number) => {
  const items = state.document.data.items;
  const nextSectionIndex = items.findIndex(
    (item, index) => index > sectionIndex && item.type === "section"
  );

  const endIndex = nextSectionIndex === -1 ? items.length : nextSectionIndex;

  return items
    .slice(sectionIndex + 1, endIndex)
    .map((item: any, index: number) => ({
      ...item,
      originalIndex: sectionIndex + 1 + index,
    }));
};

const isItemInSection = (index: number) => {
  const items = state.document.data.items;
  const previousItems = items.slice(0, index);
  const lastSection = previousItems.findLast((item) => item.type === "section");
  return !!lastSection;
};

const toggleSection = (sectionItem: any) => {
  sectionItem.isExpanded = !sectionItem.isExpanded;
};

return (_ctx: any,_cache: any) => {
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_container = _resolveComponent("v-container")!

  return (state.document)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "document-viewer"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_sheet, { class: "mx-auto px-3 pb-12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                "validate-on": "submit lazy",
                disabled: state.document.status === 'complete',
                class: "pb-12"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.document.data.items, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (item.type === 'section')
                        ? (_openBlock(), _createBlock(FormField, {
                            key: 0,
                            item: item,
                            onToggleSection: toggleSection
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSectionItems(index), (subItem, subIndex) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: subIndex }, [
                                  (subItem.type === 'text')
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        innerHTML: processLinks(subItem.content),
                                        class: "text-wrap"
                                      }, null, 8, _hoisted_1))
                                    : (_openBlock(), _createBlock(FormField, {
                                        key: 1,
                                        modelValue: 
                    state.document.data.items[subItem.originalIndex].value
                  ,
                                        "onUpdate:modelValue": ($event: any) => ((
                    state.document.data.items[subItem.originalIndex].value
                  ) = $event),
                                        item: subItem,
                                        "parent-section": item
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "item", "parent-section"]))
                                ], 64))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["item"]))
                        : (!isItemInSection(index))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (item.type === 'text')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    innerHTML: processLinks(item.content),
                                    class: "text-wrap"
                                  }, null, 8, _hoisted_2))
                                : (_openBlock(), _createBlock(FormField, {
                                    key: 1,
                                    modelValue: state.document.data.items[index].value,
                                    "onUpdate:modelValue": ($event: any) => ((state.document.data.items[index].value) = $event),
                                    item: item,
                                    "data-index": index
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "item", "data-index"]))
                            ], 64))
                          : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})